<template>
  <div>
    <!-- 面包屑 -->
    <div class="top">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>产品信息管理</el-breadcrumb-item>
        <el-breadcrumb-item>授信配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 查询 -->
    <div class="searchleft">
      <el-form :inline="true" :model="searchform">
        <el-form-item label="App名称">
          <el-input v-model="searchform.blurry" size="small" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="searchright">
      <el-button size="small" type="primary" @click="openadd">添加授信配置</el-button>
    </div>

    <!-- 列表 -->
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="platform" label="App名称" />

      <el-table-column label="授信类型">
        <template #default="{ row }">
          {{ row.model_name ? "动态" : "固定" }}
        </template>
      </el-table-column>

      <el-table-column label="授信信息">
        <template #default="{ row }">
          <span v-if="!row.model_name">
            {{ row.credit_limit_min }} ~ {{ row.credit_limit_max }} 元, 天数:
            {{ row.term_days }}
          </span>
          <span v-else>
            {{ formatCreditAdjust(row.credit_adjust) }}
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="model_name" label="模型名称" />
      <el-table-column prop="version_code" label="版本编码" />
      <el-table-column prop="white_type" label="白名单类型" />
      <el-table-column prop="des" label="描述" />
      <el-table-column label="评分区间数">
        <template #default="{ row }">
          {{ row.credit_adjust ? row.credit_adjust.length : 0 }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="150">
        <template #default="{ row }">
          <el-button size="mini" type="primary" @click="openedit(row)">编辑</el-button>
          <el-popconfirm
            title="确定删除吗？"
            @confirm="deleteConfig(row)"
            style="margin-left: 8px"
          >
            <el-button size="mini" type="danger" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗 -->
    <pop-up
      :title="status === 1 ? '添加授信配置' : '编辑授信配置'"
      :isshow="showadd"
      :haveconfirm="true"
      @close="getclose"
      @confirm="getconfirm"
    >
      <div slot="box">
        <el-form ref="form" :model="form" label-width="120px" size="small">
          <!-- App选择 -->
          <el-form-item label="App名称" prop="platform" style="width: 350px">
            <el-select
              v-model="form.platform"
              placeholder="请选择"
              @change="handlePlatformChange"
            >
              <el-option
                v-for="item in productList"
                :key="item.id"
                :label="item.productName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <!-- 固定授信 -->
          <template v-if="form.iden === 'fixed'">
            <el-form-item label="优先级">
              <el-input-number v-model="form.priority" :min="1" />
            </el-form-item>
            <el-form-item label="白名单类型">
              <el-input v-model="form.white_type" style="width: 220px" />
            </el-form-item>
            <el-form-item label="授信额度">
              <el-input-number v-model="form.credit_limit" :min="0" :step="1000" />
            </el-form-item>
            <el-form-item label="最小额度">
              <el-input-number v-model="form.credit_limit_min" :min="0" :step="1000" />
            </el-form-item>
            <el-form-item label="最大额度">
              <el-input-number v-model="form.credit_limit_max" :min="0" :step="1000" />
            </el-form-item>
            <el-form-item label="借款天数">
              <el-input-number v-model="form.term_days" :min="0" />
            </el-form-item>
            <el-form-item label="利息(%)">
              <el-input-number v-model="form.interest" :step="0.1" :min="0" :max="1" />
            </el-form-item>
            <el-form-item label="服务费(%)">
              <el-input-number
                v-model="form.service_charge"
                :step="0.1"
                :min="0"
                :max="1"
              />
            </el-form-item>
            <el-form-item label="收费方式">
              <el-select v-model="form.fee_method" style="width: 260px">
                <el-option label="放款时扣除服务费和利息" :value="1" />
                <el-option label="放款时扣除服务费，到期收取利息" :value="2" />
                <el-option label="到期收取服务费和利息" :value="3" />
              </el-select>
            </el-form-item>

            <el-form-item label="是否可分期">
              <el-switch v-model="form.can_aging" :active-value="1" :inactive-value="0" />
            </el-form-item>
            <template v-if="form.can_aging == 1">
              <el-form-item label="分期利息(%)">
                <el-input-number
                  v-model="form.aging_interest"
                  :step="0.1"
                  :min="0"
                  :max="1"
                />
              </el-form-item>
              <el-form-item label="分期天数">
                <el-input-number v-model="form.aging_day" :min="0" />
              </el-form-item>
              <el-form-item label="分期次数">
                <el-input v-model="form.aging_count" style="width: 220px" />
              </el-form-item>
            </template>

            <el-form-item label="是否可展期">
              <el-switch
                v-model="form.can_extend"
                :active-value="1"
                :inactive-value="0"
              />
            </el-form-item>
            <template v-if="form.can_extend == 1">
              <el-form-item label="展期利息(%)">
                <el-input-number
                  v-model="form.extend_interest"
                  :step="0.1"
                  :min="0"
                  :max="1"
                />
              </el-form-item>
              <el-form-item label="展期天数">
                <el-input-number v-model="form.extend_day" :min="0" />
              </el-form-item>
            </template>
          </template>

          <!-- 动态授信 -->
          <template v-else>
            <el-form-item label="模型名称" prop="model_name" style="width: 350px">
              <el-select
                v-model="form.model_name"
                placeholder="请选择"
                @change="handleModelChange"
              >
                <el-option
                  v-for="item in modelList"
                  :key="item.id"
                  :label="item.model_name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="版本编码" prop="version_code" style="width: 350px">
              <el-select
                v-model="form.version_code"
                placeholder="请选择"
                @change="handleModelVersionChange"
              >
                <el-option
                  v-for="item in modelVersionList"
                  :key="item.id"
                  :label="item.version_code"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="描述">
              <el-input type="textarea" v-model="form.des" readonly />
            </el-form-item>

            <el-form-item label="收费方式">
              <el-select v-model="form.fee_method" style="width: 260px">
                <el-option label="放款时扣除服务费和利息" :value="1" />
                <el-option label="放款时扣除服务费，到期收取利息" :value="2" />
                <el-option label="到期收取服务费和利息" :value="3" />
              </el-select>
            </el-form-item>

            <el-form-item label="白名单类型">
              <el-input v-model="form.white_type" style="width: 220px" />
            </el-form-item>

            <el-divider>评分区间配置</el-divider>

            <el-card
              v-for="(item, index) in form.credit_adjust"
              :key="index"
              style="margin-bottom: 15px"
            >
              <div slot="header">
                区间 {{ index + 1 }}
                <el-button
                  type="text"
                  style="float: right; color: red"
                  @click="removeAdjust(index)"
                  >删除</el-button
                >
              </div>

              <el-form-item label="等级">
                <el-input v-model="item.level" style="width: 220px" />
              </el-form-item>

              <el-form-item label="最小分数">
                <el-input-number v-model="item.score_min" :min="0" />
              </el-form-item>

              <el-form-item label="最大分数">
                <el-input-number v-model="item.score_max" :min="0" />
              </el-form-item>

              <el-form-item label="授信额度">
                <el-input-number v-model="item.credit_limit" :min="0" :step="1000" />
              </el-form-item>

              <el-form-item label="借款天数">
                <el-input-number v-model="item.term_days" :min="0" />
              </el-form-item>

              <el-form-item label="利息(%)">
                <el-input-number v-model="item.interest" :step="0.1" :min="0" :max="1" />
              </el-form-item>

              <el-form-item label="服务费(%)">
                <el-input-number
                  v-model="item.service_charge"
                  :step="0.1"
                  :min="0"
                  :max="1"
                />
              </el-form-item>

              <el-form-item label="是否可分期">
                <el-switch
                  v-model="item.can_aging"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
              <template v-if="item.can_aging == 1">
                <el-form-item label="分期利息(%)">
                  <el-input-number
                    v-model="item.aging_interest"
                    :step="0.1"
                    :min="0"
                    :max="1"
                  />
                </el-form-item>
                <el-form-item label="分期天数">
                  <el-input-number v-model="item.aging_day" :min="0" />
                </el-form-item>
                <el-form-item label="分期次数">
                  <el-input v-model="item.aging_count" style="width: 220px" />
                </el-form-item>
              </template>

              <el-form-item label="是否可展期">
                <el-switch
                  v-model="item.can_extend"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
              <template v-if="item.can_extend == 1">
                <el-form-item label="展期利息(%)">
                  <el-input-number
                    v-model="item.extend_interest"
                    :step="0.1"
                    :min="0"
                    :max="1"
                  />
                </el-form-item>
                <el-form-item label="展期天数">
                  <el-input-number v-model="item.extend_day" :min="0" />
                </el-form-item>
              </template>
            </el-card>

            <el-button type="primary" icon="el-icon-plus" @click="addAdjust"
              >新增评分区间</el-button
            >
          </template>
        </el-form>
      </div>
    </pop-up>
  </div>
</template>

<script>
import apiurl from "@/api/public";
import _api from "@/api/index";

export default {
  data() {
    return {
      list: [],
      productList: [],
      modelList: [],
      modelVersionList: [],
      loading: false,
      showadd: false,
      status: 1,
      searchform: { blurry: "" },
      form: {},
      pageNo: 1,
      pageSize: 10,
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("userinfo"));
    this.form = this.initForm();
    this.getList();
    this.getproductnewAll();
    this.getmodelList();
  },
  methods: {
    initForm() {
      return {
        id: null,
        platform: "",
        priority: 1,
        white_type: "",
        credit_limit: 0,
        credit_limit_min: 0,
        credit_limit_max: 0,
        term_days: 7,
        interest: 0,
        service_charge: 0,
        fee_method: 2,
        can_aging: 0,
        aging_interest: 0,
        aging_day: 7,
        aging_count: 2,
        can_extend: 0,
        extend_interest: 0,
        extend_day: 7,
        model_name: "",
        version_code: "",
        des: "",
        iden: "fixed",
        credit_adjust: [],
      };
    },

    formatCreditAdjust(arr) {
      if (!arr || !arr.length) return "";
      return arr
        .map((item) => `${item.level}:${item.score_min}-${item.score_max}`)
        .join(", ");
    },

    addAdjust() {
      this.form.credit_adjust.push({
        level: "",
        score_min: 0,
        score_max: 0,
        credit_limit: 0,
        term_days: 7,
        interest: 0,
        service_charge: 0,
        can_aging: 0,
        aging_interest: 0,
        aging_day: 7,
        aging_count: 2,
        can_extend: 0,
        extend_interest: 0,
        extend_day: 7,
      });
    },

    getproductnewAll() {
      _api.get(apiurl.productnewAll1, {}).then((res) => {
        this.productList = res.data;
      });
    },
    getmodelList() {
      _api.get(apiurl.creditModel, {}).then((res) => {
        this.modelList = res.data.model;
      });
    },
    handlePlatformChange(val) {
      const selectItem = this.productList.find((item) => item.id === val);
      if (selectItem) {
        this.form.iden = selectItem.creditType;
        if (this.form.iden === "fixed") {
          this.form.model_name = "";
          this.form.version_code = "";
          this.form.des = "";
          this.form.credit_adjust = [];
        } else {
          this.form.priority = 1;
          this.form.credit_limit = 0;
          this.form.credit_limit_min = 0;
          this.form.credit_limit_max = 0;
          this.form.term_days = 7;
          this.form.interest = 0;
          this.form.service_charge = 0;
          this.form.can_aging = 0;
          this.form.can_extend = 0;
        }
      }
    },

    handleModelChange(val) {
      this.form.version_code = "";
      this.form.des = "";
      this.modelVersionList = [];
      const selectItem = this.modelList.find((item) => item.id === val);
      if (selectItem) this.modelVersionList = selectItem.model_version || [];
    },

    handleModelVersionChange(val) {
      const selectItem = this.modelVersionList.find((item) => item.id === val);
      if (selectItem) this.form.des = selectItem.des;
    },

    removeAdjust(index) {
      this.form.credit_adjust.splice(index, 1);
    },

    openadd() {
      this.status = 1;
      this.form = this.initForm();
      this.showadd = true;
    },

    openedit(row) {
      this.status = 2;
      this.showadd = true;
      this.form = JSON.parse(JSON.stringify(row));
      if (!this.form.credit_adjust) this.form.credit_adjust = [];
      if (this.form.model_name) {
        const model = this.modelList.find((m) => m.id === this.form.model_name);
        this.modelVersionList = model ? model.model_version : [];
      } else this.modelVersionList = [];
    },

    getclose() {
      this.showadd = false;
      this.form = this.initForm();
    },

    getconfirm() {
      if (this.status === 1) {
        _api.post(apiurl.creditConfig, this.form).then(() => {
          this.$notify.success({ title: "成功", message: "新增成功" });
          this.showadd = false;
          this.getList();
        });
      } else {
        _api.put(apiurl.creditConfig, this.form).then(() => {
          this.$notify.success({ title: "成功", message: "修改成功" });
          this.showadd = false;
          this.getList();
        });
      }
    },

    deleteConfig(row) {
      _api.delete(apiurl.creditConfig, row.id).then(() => {
        this.$notify.success({ title: "成功", message: "删除成功" });
        this.getList();
      });
    },

    getList() {
      this.loading = true;
      _api
        .get(apiurl.creditConfig, { blurry: this.searchform.blurry })
        .then((res) => {
          this.loading = false;
          if (res.code === 200 && res.data) {
            // 如果返回对象，转换成数组
            this.list = Array.isArray(res.data) ? res.data : [res.data];
          } else {
            this.list = [];
          }
        })
        .catch(() => {
          this.loading = false;
          this.list = [];
        });
    },

    onSubmit() {
      this.getList();
    },
  },
};
</script>

<style scoped>
.top {
  margin-top: 15px;
}
.searchleft {
  margin-bottom: 10px;
}
.searchright {
  margin-bottom: 10px;
}
</style>
